import { Result, Spin } from 'antd';
import { useAuth } from '../context/AuthContext';

export default function ReportsContainer() {
  const { hasPermission, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Spin />
      </div>
    );
  }

  const canViewOrders = hasPermission('order_view');
  const canViewShipments = hasPermission('shipment_view');
  const { isAdmin } = useAuth();

  if (!canViewOrders && !canViewShipments && !isAdmin) {
    return (
      <Result
        status="403"
        title="No Access"
        subTitle="You don't have permission to view any reports. Contact your administrator."
      />
    );
  }

  return null;
}
